module.exports = {"411122100":"城关镇","411122101":"繁城镇","411122102":"杜曲镇","411122103":"王岗镇","411122104":"台陈镇","411122105":"巨陵镇","411122106":"瓦店镇","411122107":"三家店镇","411122108":"窝城镇","411122109":"王孟镇","411122110":"大郭镇","411122201":"皇帝庙乡","411122202":"固厢乡","411122203":"石桥乡","411122204":"陈庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411122.json
// module id = 1488
// module chunks = 0